import { render, staticRenderFns } from "./formItemNoSch.vue?vue&type=template&id=30c4365a&scoped=true"
import script from "./formItemNoSch.vue?vue&type=script&lang=js"
export * from "./formItemNoSch.vue?vue&type=script&lang=js"
import style0 from "./formItemNoSch.vue?vue&type=style&index=0&id=30c4365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4365a",
  null
  
)

export default component.exports